var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "rmfarm",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 스마트팜 제품 솔루션 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 한국형 배지치수에 적용 가능한 제품으로 작물의 뿌리 주변의 함수율 제공하여 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("작물의 품질향상과 수확량을 증대를 도와줍니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 한국형 농가 맞춤 "), _c('b', [_vm._v("배지함수율 측정장치")])]), _c('v-img', {
    staticClass: "mx-auto",
    attrs: {
      "max-width": "794",
      "aspect-ratio": 794 / 378,
      "src": "/images/sub/solution/smartfarm/rmfarm-img.png",
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('tit-wrap-large', {
          staticClass: "tit-wrap--lg",
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 알엠팜은 조달청 혁신장터에 등록되어 있는 우수 연구개발 혁신 제품으로 "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v("국내 농업환경에 가장 최적화 되어있습니다. ")];
            },
            proxy: true
          }])
        }, [_c('b', [_vm._v("혁신성과 기술력을 인정받은 알엠팜")])]), _c('v-row', {
          staticClass: "row--lg"
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "270",
            "aspect-ratio": 270 / 68,
            "src": "/images/sub/solution/smartfarm/rmfarm-img2.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" 알엠팜 고급형 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("측정항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 실시간 무게, 급액량, 배액량, 배액EC, 배액pH, 배지온도, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("온도, 습도 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("적용분야")];
            },
            proxy: true
          }])
        }, [_vm._v(" 파프리카, 토마토, 딸기 등 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("시설재배 작물 ")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "304",
            "aspect-ratio": 304 / 90,
            "src": "/images/sub/solution/smartfarm/rmfarm-img3.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" 알엠팜 기본형 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("측정항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 실시간 무게, 급액량, 배액량, "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("배액EC, 배액pH ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("적용분야")];
            },
            proxy: true
          }])
        }, [_vm._v(" 파프리카, 토마토 등 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("시설재배 작물 ")])], 1)], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade-left",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 374 / 298,
            "content-class": "d-flex pa-20px"
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "260",
            "aspect-ratio": 260 / 132,
            "src": "/images/sub/solution/smartfarm/rmfarm-img4.png"
          }
        })], 1)], 1), _c('div', {
          staticClass: "mt-20px mt-md-40px"
        }, [_c('tit-wrap-sprout', [_vm._v(" 알엠팜 보급형 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("측정항목")];
            },
            proxy: true
          }])
        }, [_vm._v(" 실시간 무게, 급액량, 배액량 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("적용분야")];
            },
            proxy: true
          }])
        }, [_vm._v(" 파프리카, 토마토 등 배지기반 시설재배 작물 ")])], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "rounded": "",
            "color": "grey lighten-5",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "800",
            "width": _vm.$vuetify.breakpoint.lgAndUp ? '800' : '',
            "aspect-ratio": 800 / 376,
            "src": "/images/sub/solution/smartfarm/rmfarm-img5.png"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 자체 개발 소프트웨어로 간편한 작동과 사용자 친화적인 인터페이스로 누구나 쉽게 사용할 수 있습니다. "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v("PC, 태블릿, 모바일 등에서 원하는 정보 확인이 가능합니다. ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 웹과 모바일 앱에서 쉽고 간편한 실시간 모니터링 ")])], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img6.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 식물 근권부 함수율 측정장치 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 특허등록 ")])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img7.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 식물 근권부 함수율 측정장치 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 농업기계 목록집 등록 ")])], 1), _c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "300"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/smartfarm/rmfarm-img8.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 조달청 혁신장터 전용몰 등록 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 혁신제품 등록 ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-container', [_c('v-divider', {
    staticClass: "grey lighten-3"
  })], 1), _c('page-section', {
    staticClass: "page-section--last",
    attrs: {
      "id": "rmfarm-portfolio"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" 포트폴리오 ")];
      },
      proxy: true
    }, {
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('div', {
          staticClass: "mx-auto px-12px",
          staticStyle: {
            "max-width": "1480px"
          }
        }, [_c('v-tabs-items', {
          attrs: {
            "touchless": ""
          },
          model: {
            value: _vm.tab,
            callback: function callback($$v) {
              _vm.tab = $$v;
            },
            expression: "tab"
          }
        }, [_c('v-tab-item', {
          attrs: {
            "value": "rmfarm-high-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-high-slide')], 1), _c('v-tab-item', {
          attrs: {
            "value": "rmfarm-basic-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-basic-slide')], 1), _c('v-tab-item', {
          attrs: {
            "value": "rmfarm-entry-tab",
            "transition": "fade-transition",
            "reverse-transition": "fade-transition"
          }
        }, [_c('rmfarm-entry-slide')], 1)], 1)], 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "tabs-wrap"
  }, [_c('v-tabs', {
    staticClass: "v-tabs--btn",
    attrs: {
      "hide-slider": "",
      "show-arrows": "",
      "centered": "",
      "center-active": ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('u-tab', {
    attrs: {
      "to": "#rmfarm-high-tab",
      "id": "rmfarm-high-tab"
    }
  }, [_vm._v("알엠팜 고급형")]), _c('u-tab', {
    attrs: {
      "to": "#rmfarm-basic-tab",
      "id": "rmfarm-basic-tab"
    }
  }, [_vm._v("알엠팜 기본형")]), _c('u-tab', {
    attrs: {
      "to": "#rmfarm-entry-tab",
      "id": "rmfarm-entry-tab"
    }
  }, [_vm._v("알엠팜 보급형")])], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }